<template>
  <v-dialog v-model="dialog" max-width="600px" persistent @keydown.esc="onDialogClose">
    <v-snackbar
      v-model="showSnackbar"
      :color="snackbarColor"
      :timeout="snackbarTimeout"
      :top="true"
    >
      {{ snackbarMsg }}
      <v-btn dark text @click="showSnackbar = false">CLOSE</v-btn>
    </v-snackbar>

    <v-row no-gutters>
      <v-col>
        <v-card flat tile color="white">
          <v-card-title class="headline dialog-header-title py-1"
            >Select a tonnage rate for {{ transactionType }} transport</v-card-title
          >

          <v-card-text class="px-2 dialog-header-title" v-if="sortedRates.length > 0">
            <v-row no-gutters>
              <v-col>
                <v-card tile color="white">
                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-center">Tonnage Size</th>
                          <th class="text-center">Max CBM</th>
                          <th class="text-center">Quantity</th>
                          <th class="text-center">Currency</th>
                          <th class="text-center">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <span v-on="on">B. PPU</span>
                              </template>
                              Base price per unit in original currency
                            </v-tooltip>
                          </th>
                          <th class="text-center">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <span v-on="on">B. CPU</span>
                              </template>
                              Base cost per unit in original currency
                            </v-tooltip>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in sortedRates" :key="item.tonnage_size">
                          <td class="pl-2">
                            <v-row justify="space-between" no-gutters>
                              <v-col cols="9">
                                <span
                                  >{{ item.tonnage_size }}
                                  {{ item.tonnage_size > 1 ? "Tonnes" : "Tonne" }}</span
                                >
                              </v-col>

                              <v-col
                                v-if="
                                  selectedTonnageRate.tonnage_size == item.tonnage_size
                                "
                              >
                                <v-icon color="success" size="20"
                                  >mdi-check-circle</v-icon
                                >
                              </v-col>

                              <v-col v-else>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      v-on="on"
                                      x-small
                                      icon
                                      color="grey"
                                      @click="tonnageSelected(item)"
                                    >
                                      <v-icon size="20">mdi-check-circle</v-icon>
                                    </v-btn>
                                  </template>
                                  Click to select this tonnage rate
                                </v-tooltip>
                              </v-col>
                            </v-row>
                          </td>
                          <td>{{ item.max_cbm }}</td>
                          <td>{{ item.quantity }}</td>
                          <td>{{ item.currency }}</td>
                          <td>{{ item.price.base.toFixed(2) }}</td>
                          <td>{{ item.cost.base.toFixed(2) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text v-else>
            <v-alert tile style="z-index: 1" type="info" class="my-10"
              >There are no available tonnage rates</v-alert
            >
          </v-card-text>

          <v-divider class="my-1"></v-divider>

          <v-card-actions>
            <v-row justify="end">
              <v-btn
                small
                tile
                depressed
                color="error"
                class="font-weight-bold text-button"
                @click="onDialogClose"
                >CLOSE</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-dialog>
</template>

<script>
import constant from "@/const";
export default {
  props: ["dialog", "actualTonnageRate", "tonnageRates", "transaction"],

  data() {
    return {
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      selectedTonnageRate: null,
      transactionType: null,

      rates: [],
    };
  },

  created() {},

  mounted() {},

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.selectedTonnageRate = this.actualTonnageRate;
        this.rates = this.tonnageRates;
      }
    },
    transaction() {
      if (this.transaction != null) {
        this.transactionType = this.transaction.toLowerCase();
      }
    },
  },

  methods: {
    tonnageSelected(tonnageRate) {
      this.selectedTonnageRate = tonnageRate;
      this.$emit("tonnage-selected", this.selectedTonnageRate);
    },

    /**
     * Close dialog
     */
    onDialogClose() {
      this.$emit("dialog-close");
    },
  },

  computed: {
    sortedRates() {
      return this.rates.sort(function (a, b) {
        return a.tonnage_size - b.tonnage_size;
      });
    },
  },
};
</script>

<style scoped>
.v-data-table {
  border: 2px solid #e0e0e0;
}

::v-deep .v-data-table thead tr th {
  text-align: center;
  text-transform: none;
  color: black !important;
  font-weight: bold;
  border: 1px;
  padding: 2px 0.2rem;
  height: 20px !important;
  line-height: 30px;
}

.v-data-table td {
  /* padding: 0px; */
  /* height: 30px; */
  border-right: thin solid rgba(0, 0, 0, 0.12);
  border-top: thin solid rgba(0, 0, 0, 0.12);
}

::v-deep .v-data-table__wrapper {
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>
